import api, { openApi } from "../../services/api";
import { useCallback } from 'react';

const useSettings = () => {
  const getAll = useCallback(async (params) => {
    const { data } = await api.request({
      url: "/settings",
      method: "GET",
      params,
    });
    return data;
  }, []);

  const update = useCallback(async (data) => {
    const { data: responseData } = await api.request({
      url: `/settings/${data.key}`,
      method: "PUT",
      data,
    });
    return responseData;
  }, []);

  const get = useCallback(async (param) => {
    const { data } = await api.request({
      url: `/setting/${param}`,
      method: "GET",
    });
    return data;
  }, []);

  const getPublicSetting = useCallback(async (key, options = {}) => {
    try {
      const runtimeOrigin =
        options.requestOrigin || window?.location?.origin || undefined;
      const runtimeHost =
        options.requestHost || window?.location?.host || undefined;
      const runtimeProtocol =
        options.requestProtocol ||
        (window?.location?.protocol
          ? window.location.protocol.replace(":", "")
          : undefined);

      const { data } = await openApi.request({
        url: `/public-settings/${key}`,
        method: "GET",
        params: {
          companyToken: options.companyToken || undefined,
          requestOrigin: runtimeOrigin,
          requestHost: runtimeHost,
          requestProtocol: runtimeProtocol,
        },
      });
      return data;
    } catch (error) {
      const status = error?.response?.status;
      if (status !== 403) {
        console.error(`Erro ao obter configuração pública: ${key}`, error);
      }
      return null;
    }
  }, []);

  return {
    getAll,
    update,
    get,
    getPublicSetting,
  };
};

export default useSettings;
